import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

import { InspectionSectionsExpandState } from './interfaces';

export const labelConfig: IRadioButtonOption<number>[] = [
  {
    label: 'Inspections Summary Report',
    value: -1,
    groupValue: null,
  },
];

export enum InspectionQueryType {
  All = 0,
  Active = 1,
  Archived = 2,
}

export enum InspectionHasIssues {
  Yes = 1,
  No = 0,
  NA = -1,
  Any = -2,
}

export const inspectionsTitleConfig: IRadioButtonOption<number>[] = [
  {
    label: 'Inspections',
    value: InspectionQueryType.Active,
    groupValue: null,
  },
  {
    label: 'Archived inspections',
    value: InspectionQueryType.Archived,
    groupValue: null,
  },
];

export namespace InspectionsListConstants {
  export enum TimeFrame {
    Week = 1,
    Month,
    Month_3,
    Month_6,
    Year,
    AllTime,
    Custom,
    ThisWeek,
    NextTwoWeeks,
    ThisMonth,
    ThisQuarter,
    ThisYear,
  }

  export enum IncludeArchived {
    Yes = 1,
    No = 0,
  }

  export const displayedOneTimeColumns = [
    'unit.name',
    'unit.propertyName',
    'inspectionType',
    'assignee',
    'status',
    'rooms',
    'dueDate',
    'completedAt',
    'notifyWhenDone',
    'expired',
    'repeats',
    'totalInspectionTimeInSeconds',
    'actions',
  ];

  export const displayedRepeatingColumns = [
    'unit.propertyName',
    'inspectionType',
    'dueDate',
    'recurrencePeriod',
    'nextDue',
    'actions',
  ];

  export const displayedDynamicColumns = [
    'step',
    'unit.propertyName',
    'unit.portfolioName',
    'inspectionType',
    'assigneeUserName',
    'due',
    'notify',
    'until',
    'notifyWhenDone',
    'actions',
  ];

  export const displayedInReviewColumns = [
    'unit.name',
    'unit.propertyName',
    'inspectionType',
    'reviewer',
    'submitted',
    'rooms',
    'dueDate',
    'repeats',
    'actions',
  ];

  export const timeFrames = [
    { value: TimeFrame.Week, label: 'past 7 days' },
    { value: TimeFrame.Month, label: 'past 30 days' },
    { value: TimeFrame.Month_3, label: 'past 3 months' },
    { value: TimeFrame.Month_6, label: 'past 6 months' },
    { value: TimeFrame.Year, label: 'past year' },
    { value: TimeFrame.ThisWeek, label: 'this week' },
    { value: TimeFrame.NextTwoWeeks, label: 'next two weeks' },
    { value: TimeFrame.ThisMonth, label: 'this month' },
    { value: TimeFrame.ThisQuarter, label: 'this quarter' },
    { value: TimeFrame.ThisYear, label: 'this year' },
    { value: TimeFrame.AllTime, label: 'all time' },
    { value: TimeFrame.Custom, label: 'custom' },
  ];

  export enum TimeWindow {
    AnyTimeframe = 0,
    DueDateOnly = 1,
  }

  export const periodDateSearchFields = [
    { value: TimeWindow.AnyTimeframe, label: 'Any timeframe' },
    { value: TimeWindow.DueDateOnly, label: 'Due Date only' },
  ];

  export const includeArchivedList = [
    { value: IncludeArchived.Yes, label: 'Yes' },
    { value: IncludeArchived.No, label: 'No' },
  ];

  export const hasIssues = [
    { value: InspectionHasIssues.Any, label: 'Any' },
    { value: InspectionHasIssues.NA, label: 'N/A' },
    { value: InspectionHasIssues.Yes, label: 'Yes' },
    { value: InspectionHasIssues.No, label: 'No' },
  ];

  export const sectionsExpandInitialState: InspectionSectionsExpandState = {
    Standard: true,
    Bulk: true,
  };
}

export const ASSIGNEE_FILTER_DIVIDER_POSITION = 1;
